import { ReactNode } from "react";
import { Button, ButtonProps } from "..";

export const SubmitButtonBase = (
  props: ButtonProps & {
    onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
    label?: ReactNode;
  }
) => {
  const handleClick = (e: any) => {
    if (props.onClick) {
      e.preventDefault();
      props.onClick(e);
    }
  };

  const { label, onClick, ...rest } = props;

  return (
    <Button variant={"contained"} type="submit" onClick={handleClick} {...rest}>
      {label ? label : "Save"}
    </Button>
  );
};
